export const truncateString = (str: string, maxLength: number) => {
    if (str.length > maxLength) {
        str = str.substring(0, maxLength) + "...";
    }
    return str
}